<template>
  <div>
    <page-header>
      <el-button type="primary" @click="saveClientSetting">保存</el-button>
    </page-header>
    <el-divider content-position="left">
      <span>轮播图</span>
      <el-button type="primary" icon="el-icon-plus" circle style="margin-left: 12px" @click="addBannerImage"/>
    </el-divider>
    <el-table :data="clientSetting.banners" border>
      <el-table-column label="图片">
        <template #default="scope">
          <el-image class="banner-image" @click="modifyBannerImage(scope.$index)" :src="scope.row.url"/>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="clientSetting.banners.splice(scope.$index,1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">
      <span>快速链接</span>
      <el-button type="primary" icon="el-icon-plus" circle style="margin-left: 12px" @click="addQuickLink"/>
    </el-divider>
    <el-table :data="clientSetting.quickLinks" border>
      <el-table-column label="图标">
        <template #default="scope">
          <el-image class="category-icon" :src="scope.row.image.url"/>
        </template>
      </el-table-column>
      <el-table-column label="文本" prop="name"/>
      <el-table-column label="链接分类">
        <template #default="scope">
          <span>{{ scope.row.category.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="clientSetting.quickLinks.splice(scope.$index,1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">
      <span>热门商户</span>
      <el-button type="primary" icon="el-icon-plus" circle style="margin-left: 12px" @click="selectHotMerchant"/>
    </el-divider>
    <el-table :data="clientSetting.hotMerchants" border>
      <el-table-column label="商户" prop="name"/>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="clientSetting.hotMerchants.splice(scope.$index,1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <image-selector v-model="imageSelector.visible" :max-count="imageSelector.maxCount" @select="selectImageCallback"/>
    <el-dialog :visible.sync="quickLinkDialog.visible" append-to-body :close-on-click-modal="false" top="20px"
               width="600px">
      <el-form label-width="80px">
        <el-form-item label="图标">
          <image-placeholder @click="selectQuickLinkImage" :image="quickLinkDialog.form.image"/>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="quickLinkDialog.form.name"/>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="quickLinkDialog.form.category" value-key="id">
            <el-option v-for="category of categories" :key="category"  :value="category" :label="category.name"/>
          </el-select>
        </el-form-item>
      </el-form>
      <button-line>
        <el-button type="primary" @click="confirmAddQuickLink">确定</el-button>
        <el-button @click="quickLinkDialog.visible = false">取消</el-button>
      </button-line>
    </el-dialog>
    <el-dialog :visible.sync="merchantDialog.visible" append-to-body :close-on-click-modal="false" top="20px">
      <page-header>
        <el-input v-model="merchantDialog.filter.search"/>
      </page-header>
      <table-union-pager :data="merchantDialog.tableData">
        <el-table-column label="图片">
          <template #default="scope">
            <el-image class="merchant-image" :src="scope.row.image"/>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name"/>
        <el-table-column label=" ">
          <template #default="scope">
            <el-button type="primary" @click="confirmSelectHotMerchant(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </table-union-pager>
      <button-line>
        <el-button @click="merchantDialog.visible = false;">取消</el-button>
      </button-line>
    </el-dialog>

  </div>
</template>

<script>
import api from "@/utils/api";
import PageHeader from "@/components/PageHeader";
import ImageSelector from "@/components/ImageSelector";
import ButtonLine from "@/components/ButtonLine";
import ImagePlaceholder from "@/components/ImagePlaceholder";
import TableUnionPager from "@/components/TableUnionPager";

export default {
  name: "ClientSetting",
  components: {TableUnionPager, ImagePlaceholder, ButtonLine, ImageSelector, PageHeader},
  data() {
    return {
      clientSetting: {
        banners: [],
        quickLinks: [],
        hotMerchants: []
      },
      imageSelector: {
        visible: false,
        mode: 'addBanner',
        maxCount: 1,
        index: 0
      },
      quickLinkDialog: {
        visible: false,
        index: -1,
        form: {
          image: null,
          name: '',
          category: null
        }
      },
      categories: [],
      merchantDialog: {
        visible: false,
        index: -1,
        tableData: {
          list: [],
          totalCount: 0,
          page: 1,
          pageSize: 10
        },
        filter: {
          search: ''
        }
      }
    }
  },
  methods: {
    getClientSetting() {
      api.clientSetting_getClientSetting().then(res => {
        this.clientSetting = res.data.data;
      })
    },
    addBannerImage() {
      this.imageSelector.mode = 'addBanner';
      this.imageSelector.maxCount = 1;
      this.imageSelector.visible = true;
    },
    modifyBannerImage(index) {
      this.imageSelector.mode = 'editBanner';
      this.imageSelector.maxCount = 1;
      this.imageSelector.index = index;
      this.imageSelector.visible = true;
    },
    selectQuickLinkImage() {
      this.imageSelector.mode = 'quickLink';
      this.imageSelector.maxCount = 1;
      this.imageSelector.visible = true;
    },
    selectImageCallback(images) {
      if (this.imageSelector.mode === 'addBanner') {
        this.clientSetting.banners.push({
          id: images[0].id,
          url: images[0].url
        });
      }
      if (this.imageSelector.mode === 'editBanner') {
        this.$set(this.clientSetting.banners, this.imageSelector.index, {
          id: images[0].id,
          url: images[0].url
        });
      }
      if (this.imageSelector.mode === 'quickLink') {
        this.quickLinkDialog.form.image = images[0];
      }
    },
    getMerchantCategories() {
      api.merchantCategory_getMerchantCategories({
        countMerchant: false
      }).then(res => {
        this.categories = res.data.data;
      });
    },
    addQuickLink() {
      this.quickLinkDialog.index = -1;
      this.quickLinkDialog.form = {
        image: null,
        name: '',
        category: null
      }
      this.quickLinkDialog.visible = true;
      this.getMerchantCategories();
    },
    confirmAddQuickLink() {
      if (!this.quickLinkDialog.form.image) {
        return;
      }
      if (!this.quickLinkDialog.form.name) {
        return;
      }
      if (!this.quickLinkDialog.form.category) {
        return;
      }
      this.clientSetting.quickLinks.push({
        image: this.quickLinkDialog.form.image,
        name: this.quickLinkDialog.form.name,
        category: this.quickLinkDialog.form.category
      });
      this.quickLinkDialog.visible = false;
    },
    selectHotMerchant() {
      this.merchantDialog.visible = true;
      this.merchantDialog.filter.search = '';
      this.getMerchantList(1);
    },
    getMerchantList(page) {
      this.merchantDialog.tableData.page = page;
      api.merchant_getMerchantList({
        page: page,
        pageSize: 10,
        search: this.merchantDialog.filter.search
      }).then(res => {
        this.merchantDialog.tableData.list = res.data.data.list;
        this.merchantDialog.tableData.totalCount = res.data.data.totalCount;
      });
    },
    confirmSelectHotMerchant(merchant) {
      this.clientSetting.hotMerchants.push({
        id: merchant.id,
        name: merchant.name,
        image: merchant.image
      });
      this.merchantDialog.visible = false;
    },
    saveClientSetting() {
      let bannerImageIds = [];
      let quickLinkImageIds = [];
      let quickLinkCategoryIds = [];
      let quickLinkNames = [];
      let hotMerchantIds = [];
      for (let banner of this.clientSetting.banners) {
        bannerImageIds.push(banner.id);
      }
      for (let quickLink of this.clientSetting.quickLinks) {
        quickLinkImageIds.push(quickLink.image.id);
        quickLinkCategoryIds.push(quickLink.category.id);
        quickLinkNames.push(quickLink.name);
      }
      for (let hotMerchant of this.clientSetting.hotMerchants) {
        hotMerchantIds.push(hotMerchant.id);
      }
      api.clientSetting_saveClientSetting({
        bannerImageIds: bannerImageIds,
        quickLinkImageIds: quickLinkImageIds,
        quickLinkCategoryIds: quickLinkCategoryIds,
        quickLinkNames: quickLinkNames,
        hotMerchantIds: hotMerchantIds
      }).then(res => {
        if (res.data.code !== '000') {
          this.$message.error(res.data.message);
          return;
        }
        this.$message.success('保存成功');
        this.getClientSetting();
      })
    }
  },
  mounted() {
    this.getClientSetting();
  }
}
</script>

<style lang="scss" scoped>
.banner-image {
  width: 80px;
  height: 80px;
  cursor: pointer;
}

.category-icon {
  width: 60px;
  height: 60px;
}

.merchant-image {
  width: 60px;
  height: 60px;
}
</style>
